/** @file Merges records into a list kept in ascending key order (a newer copy replaces an older one), capped. */

/** `list` plus `added`, ascending by `key`, at most the last `max`; appending one newer record skips the sort. */
export function mergeByKey<T>(list: readonly T[], added: readonly T[], key: (item: T) => number, max: number): T[] {
  const last = list.at(-1);
  const [first] = added;
  if (added.length === 1 && first !== undefined && (last === undefined || key(last) < key(first))) return [...list, first].slice(-max);
  const byKey = new Map(list.map((item): [number, T] => [key(item), item]));
  for (const item of added) byKey.set(key(item), item);
  return [...byKey.values()].sort((a, b) => key(a) - key(b)).slice(-max);
}
